function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    @media (min-width: ",
        ") {\n      ",
        "\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    @media (min-width: ",
        ") {\n      ",
        "\n    }\n  "
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    @media (min-width: ",
        ") {\n      ",
        "\n    }\n  "
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    @media (min-width: ",
        ") {\n      ",
        "\n    }\n  "
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n    margin-bottom: 0.75rem;\n  "
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 0.5rem;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n    font-size: 0.875rem;\n    margin-bottom: 0.25rem;\n  "
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 0.2rem;\n  \n  ",
        "\n  \n  .dark & {\n    color: #e5e7eb;\n  }\n  \n  .required {\n    color: #ef4444;\n    margin-left: 0.25rem;\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n    font-size: 0.875rem;\n  "
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: #6b7280;\n  \n  ",
        "\n  \n  .dark & {\n    color: #9ca3af;\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n    font-size: 0.875rem;\n  "
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: #ef4444;\n  \n  ",
        "\n  \n  .dark & {\n    color: #f87171;\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
import { css } from '@emotion/react';
// 미디어 쿼리 브레이크포인트
var breakpoints = {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px'
};
// 미디어 쿼리 헬퍼 함수
var media = {
    sm: function(styles) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return css(_templateObject(), breakpoints.sm, css.apply(void 0, [
            styles
        ].concat(_to_consumable_array(args))));
    },
    md: function(styles) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return css(_templateObject1(), breakpoints.md, css.apply(void 0, [
            styles
        ].concat(_to_consumable_array(args))));
    },
    lg: function(styles) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return css(_templateObject2(), breakpoints.lg, css.apply(void 0, [
            styles
        ].concat(_to_consumable_array(args))));
    },
    xl: function(styles) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return css(_templateObject3(), breakpoints.xl, css.apply(void 0, [
            styles
        ].concat(_to_consumable_array(args))));
    }
};
export var FormFieldContainer = styled.div(_templateObject5(), media.md(_templateObject4()));
export var FieldLabel = styled.label(_templateObject7(), media.md(_templateObject6()));
export var HelpText = styled.p(_templateObject9(), media.md(_templateObject8()));
export var ErrorText = styled.p(_templateObject11(), media.md(_templateObject10()));
